export enum StatusApproval {

    AprovacaoPendente = 1,
    PagamentoPendente = 2,
    Pago = 3,
    AguardandoRacional = 4,
    PendenteRegularizacaoEmpresa = 5
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/StatusApproval.ts